export enum Routes {
  //root stack:
  NftDetails = 'NftDetails',
  OfferDetails = 'OfferDetails',
  SignIn = 'SignIn',
  SignUp = 'SignUp',
  UserDetailsForm = 'UserDetailsForm',

  // stacks:
  HistoryStack = 'HistoryStack',
  MainTab = 'MainTab',
  OffersStack = 'OffersStack',
  UserStack = 'UserStack',
  WalletStack = 'WalletStack',

  //offersStack screens
  OffersList = 'OffersList',

  //userStack screens
  UserProfile = 'UserProfile',

  //walletStack screens
  Wallet = 'Wallet',
  Details = 'Details',

  // historyStack screens
  History = 'History',
}

export type BottomTabRouteName =
  | typeof Routes.HistoryStack
  | typeof Routes.OffersStack
  | typeof Routes.UserStack
